import React from 'react';
import classNames from "classnames";
import {Link} from "../link/link";
import styles from "./footer-buttons.module.scss";

export const FooterButtons = ({controller, onClose, onClick, buttonLabel, buttonLinkModel, shouldRenderEntityButton}) => {
  const {terms} = controller;
  const {WEB_PLAYER_CARD_POPUP_STATS_CLOSE} = terms;

  const closeButtonProps = {
    className: classNames(styles.button, styles.close_button),
    label: WEB_PLAYER_CARD_POPUP_STATS_CLOSE,
    onClick: () => {
      onClose()
    }
  }

  const buttonProps = {
    className: classNames(styles.button),
    label: buttonLabel,
    model: buttonLinkModel,
    onClick
  }

  return (
    <div className={classNames(styles.container)}>
      {
        shouldRenderEntityButton ? <Link {...buttonProps}>{buttonLabel}</Link> : null
      }
      <div {...closeButtonProps}>{WEB_PLAYER_CARD_POPUP_STATS_CLOSE}</div>
    </div>
  )
};
